import * as PIXI from "pixi.js";

import App from "./service/App";
import AudioManager from "./service/AudioManager";
import SavedData from "./service/SavedData";
import GameState from "./state/GameState";
import GameplayScreen from "./screen/GameplayScreen";
import Main from "./Main";
import MultiplayerEventManager from "./service/MultiplayerEventManager";


export default class ServiceLocator
{
    // #region Attributes //

    // private:

    private static _gMain: Main = null;
    private static _gAudioManager: AudioManager = null;
    private static _gApp: App = null;
    private static _gSavedData: SavedData = null;
    private static _gResources: PIXI.utils.Dict<PIXI.LoaderResource> = null;
    private static _gGameState: GameState = null;
    private static _gMultiplayerEventManager: MultiplayerEventManager = null;

    // TODO: Add more global services here.
    
    // #endregion //


    // #region Properties //

    public static set main( value: Main ) { if ( !this._gMain ) { this._gMain = value; } }
    public static set app( value: App ) { if ( !this._gApp ) { this._gApp = value; } }
    public static set audio( value: AudioManager ) { if ( !this._gAudioManager ) { this._gAudioManager = value; } }
    public static set saved( value: SavedData ) { if ( !this._gSavedData ) { this._gSavedData = value; } }
    public static set resources( value: PIXI.utils.Dict<PIXI.LoaderResource> ) { if ( !this._gResources ) { this._gResources = value; } }
    public static set game( value: GameState ) { if ( !this._gGameState ) { this._gGameState = value; } }
    public static set multiplayerEventManager( value: MultiplayerEventManager ) { if ( !this._gMultiplayerEventManager ) { this._gMultiplayerEventManager = value; } }

    public static get main(): Main { return this._gMain; }
    public static get app(): App { return this._gApp; }
    public static get audio(): AudioManager { return this._gAudioManager; }
    public static get saved(): SavedData { return this._gSavedData; }
    public static get resources(): PIXI.utils.Dict<PIXI.LoaderResource> { return this._gResources; }
    public static get game(): GameState { return this._gGameState; }
    public static get multiplayerEventManager(): MultiplayerEventManager { return this._gMultiplayerEventManager; }

    // #endregion


    // #region Methods //

    // private:

    private constructor() {}

    // #endregion //
}